import { MultiSelectOutlined } from '@amelio/ui-library';

import type {
    OnSelectCompanyAttributeOption,
    SelectedFilters,
} from '@/hooks/filters/useCompanyAttributesFilters';
import type { MultiSelectAccent } from '@amelio/ui-library';

import { decodeAndSanitize } from '@/utils/htmlSanitizer';
import { getLocalizedText } from '@/utils/localization';

interface AttributeSelectListProps {
    attribute: OnSelectCompanyAttributeOption['attribute'];
    filters: SelectedFilters;
    accent?: MultiSelectAccent;
    isReadOnly?: boolean;
    dataTestId?: string;
    selectCompanyAttributeOption: (params: OnSelectCompanyAttributeOption) => void;
}

export const AttributeSelectList = ({
    attribute,
    filters,
    accent,
    isReadOnly = false,
    dataTestId,
    selectCompanyAttributeOption,
}: AttributeSelectListProps) => {
    const filterKey = Object.entries(filters).find(([, values]) =>
        values.some((attributeValues) =>
            attribute.values?.some((value) => value.id === attributeValues.id),
        ),
    )?.[0];

    const selectedValues: string[] = filterKey
        ? (filters[filterKey]
              ?.map((value) => value.id)
              .filter((id): id is string => id !== undefined) ?? [])
        : [];

    return (
        <div
            key={attribute.name}
            className={'inline-block w-fit max-w-full min-w-[12.5rem] shrink-0'}
        >
            <MultiSelectOutlined
                accent={accent}
                dataTestId={dataTestId}
                options={(attribute.values ?? []).map((value) => ({
                    label: decodeAndSanitize(
                        'names' in value ? getLocalizedText(value.names) : value.name,
                    ),
                    value: value.id,
                }))}
                onChange={(value) => selectCompanyAttributeOption({ value, attribute })}
                showSelection={true}
                label={decodeAndSanitize(attribute.name)}
                values={selectedValues}
                readOnly={isReadOnly}
            />
        </div>
    );
};
